export const DolyameIcon = () => {
	return (
		<div>
			<svg width="56" height="8" viewBox="0 0 56 8" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clipPath="url(#clip0_29764_721)">
					<path d="M9.93925 0H8.60443V6.76887H9.93925V0Z" fill="white" />
					<path d="M7.07111 0.378764H5.73629V7.14749H7.07111V0.378764Z" fill="white" />
					<path d="M4.20296 0.801615H2.86814V7.57162H4.20296V0.801615Z" fill="white" />
					<path d="M1.33482 1.22917H0L5.08626e-06 8H1.33482L1.33482 1.22917Z" fill="white" />
					<path
						d="M45.194 3.60631L43.0447 1.21671H41.7882V6.74948H43.1001V3.21946L45.0623 5.31088H45.3047L47.2332 3.21946V6.74948H48.5451V1.21671H47.2886L45.194 3.60631Z"
						fill="white"
					/>
					<path
						d="M54.795 1.21671L51.5435 4.8128V1.21671H50.2316V6.74948H51.4335L54.685 3.15338V6.74948H55.9969V1.21671H54.795Z"
						fill="white"
					/>
					<path
						d="M34.7222 3.24122C34.7222 4.12211 35.2039 4.81603 35.9433 5.10697L34.5568 6.74948H36.1625L37.4238 5.25527H38.7886V6.74948H40.1005V1.21671H36.7606C35.5154 1.21671 34.7222 2.06858 34.7222 3.24122ZM38.7895 2.43528V4.07134H37.0039C36.4082 4.07134 36.0886 3.73929 36.0886 3.25251C36.0886 2.76572 36.4194 2.43367 37.0039 2.43367L38.7895 2.43528Z"
						fill="white"
					/>
					<path
						d="M28.626 2.32326C28.5457 4.22608 28.1443 5.45433 27.3583 5.45433H27.1616V6.78252L27.3712 6.7938C28.9472 6.88165 29.8183 5.49866 29.9612 2.478H32.0341V6.74948H33.3436V1.21671H28.6702L28.626 2.32326Z"
						fill="white"
					/>
					<path
						d="M23.6877 1.1394C21.9134 1.1394 20.6369 2.36765 20.6369 3.98276C20.6369 5.65347 22.0258 6.8382 23.6877 6.8382C25.4187 6.8382 26.7635 5.58738 26.7635 3.98276C26.7635 2.37813 25.4187 1.1394 23.6877 1.1394ZM23.6877 5.51001C22.685 5.51001 22.0017 4.8572 22.0017 3.98276C22.0017 3.08655 22.6858 2.45147 23.6877 2.45147C24.6897 2.45147 25.3962 3.11557 25.3962 3.98276C25.3962 4.84995 24.6801 5.51001 23.6877 5.51001Z"
						fill="white"
					/>
					<path
						d="M19.2456 1.22714H14.6155L14.5713 2.3337C14.5055 3.92784 14.0896 5.44381 13.3036 5.46558L12.9399 5.47686V8.00002L14.263 7.99736V6.75024H18.8594V7.99736H20.1937V5.46558H19.2456V1.22714ZM17.9337 5.46558H15.1341C15.6078 4.74668 15.8615 3.70621 15.9057 2.48924H17.9337V5.46558Z"
						fill="white"
					/>
				</g>
				<defs>
					<clipPath id="clip0_29764_721">
						<rect width="56" height="8" fill="white" />
					</clipPath>
				</defs>
			</svg>
		</div>
	)
}
